// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"lV","mainContent":"mV","activeSidebar":"nV"};